import "./Roller.scss"

import React, { FC, ReactNode, useEffect } from "react"

import { WOW_MONEY_BANNER_ROTATE_INTERVAL } from "live/constants"

interface Props {
  children: ReactNode
}

/** 두 배너를 prev/current/next 로 순환시키며 위→아래로 슬라이드 전환한다 */
const Roller: FC<Props> = ({ children }) => {
  useEffect(() => {
    const rollingTimer = setInterval(() => {
      const prevElement = document.querySelector(".wmRoller .prev")
      const currentElement = document.querySelector(".wmRoller .current")
      const nextElement = document.querySelector(".wmRoller .next")

      prevElement?.classList.remove("prev")
      prevElement?.classList.add("next")

      currentElement?.classList.remove("current")
      currentElement?.classList.add("prev")

      nextElement?.classList.remove("next")
      nextElement?.classList.add("current")

      setTimeout(() => {
        currentElement?.classList.remove("prev")
        currentElement?.classList.add("next")
      }, 500)
    }, WOW_MONEY_BANNER_ROTATE_INTERVAL)

    return () => {
      clearInterval(rollingTimer)
    }
  }, [])

  return <ul className="wmRoller">{children}</ul>
}

export default Roller
